export const ADD_DIAGNOSTIC_MESSAGE = "ADD_DIAGNOSTIC_MESSAGE";
export const SET_DIAGNOSTIC_MESSAGES = "SET_DIAGNOSTIC_MESSAGES";
export const CLEAR_DIAGNOSTIC_MESSAGES = "CLEAR_DIAGNOSTIC_MESSAGES";
